import React, {useRef, useState, useEffect} from 'react';
import { Menu, Container, Button, Image as SemanticImage, Icon, Sidebar, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import LanguageDropdown from '../Utils/LanguageDropdown';
import CreditsWidget from '../Components/CreditsWidget';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import logoStoriaCleanWebp from '../assets/logoStoriaClean_720p.webp';

const Navbar = ({ fixed, env, handleSignOut }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [logoSrc, setLogoSrc] = useState(logoStoriaCleanWebp);
    const { t } = useTranslation();
    const toggleMenu = () => setMenuOpen(!menuOpen);
    const isMobile = useMediaQuery({ maxWidth: 767 });

    useEffect(() => {
        const imgWebp = new Image();
        imgWebp.onload = () => {
            setLogoSrc(logoStoriaCleanWebp);
        };

        const checkInterval = setInterval(() => {
            if (!imgWebp.complete || imgWebp.naturalHeight === 0) {
                setLogoSrc(logoStoriaCleanWebp);
            }
        }, 30000);
        return () => {
            clearInterval(checkInterval);
        };
    }, []);

    return (
        <>
            {isMobile ? (
                <>
                    {/* Mobile Sidebar */}
                    <Sidebar
                        direction='right'
                        as={Menu}
                        animation="overlay"
                        inverted
                        onHide={() => setMenuOpen(false)}
                        vertical
                        visible={menuOpen}
                        style={{ backgroundColor: '#00201f' }}
                    >
                        <Menu.Item as={Link} to="/" onClick={() => setMenuOpen(false)} style={{ color: '#fff' }}>
                            {t('Home')}
                        </Menu.Item>
                        <Menu.Item as={Link} to="/SelectStory" onClick={() => setMenuOpen(false)} style={{ color: '#fff' }}>
                            {t('Story Mode')}
                        </Menu.Item>
                        <Menu.Item as={Link} to={env.user ? "/Create" : "/CreateHomePage"} onClick={() => setMenuOpen(false)} style={{ color: '#fff' }}>
                            {t('Creation Mode')}
                        </Menu.Item>
                        {env.user ? (
                            <>
                                <Menu.Item>
                                    {env.user.photoURL && (
                                        <SemanticImage src={env.user.photoURL} avatar alt="Profile Image" />
                                    )}
                                    <span style={{ color: '#fff', marginRight: '0.5em' }}>
                                        {env.user.displayName || env.user.email}
                                    </span>
                                </Menu.Item>
                                <Menu.Item>
                                    <CreditsWidget />
                                </Menu.Item>
                                <Menu.Item>
                                    <Button onClick={handleSignOut} style={{ backgroundColor: '#004F78', color: '#fff' }}>
                                        {t('SignOut')}
                                    </Button>
                                </Menu.Item>
                            </>
                        ) : (
                            <>
                                <Menu.Item>
                                    <CreditsWidget />
                                </Menu.Item>
                                <Menu.Item>
                                    <Button as={Link} to="/login" inverted style={{ width: '100%' }}>
                                        {t('LogIn')}
                                    </Button>
                                </Menu.Item>
                                <Menu.Item>
                                    <Button as={Link} to="/signup" style={{ width: '100%', backgroundColor: '#004F78', color: '#fff' }}>
                                        {t('SignUp')}
                                    </Button>
                                </Menu.Item>
                            </>
                        )}
                        <Menu.Item as={Link} to="/settings">
                            <Icon name="setting" inverted />
                            {t('Settings')}
                        </Menu.Item>
                        <Menu.Item>
                            <LanguageDropdown />
                        </Menu.Item>
                    </Sidebar>

                    {/* Mobile Top Bar */}
                    <Menu fixed="top" inverted style={{ backgroundColor: '#00201f', border: 'none', boxShadow: 'none' }}>
                        <Container>
                            <Menu.Item as={Link} to="/" header style={{ color: '#fff', textAlign: 'center', flex: 1 }}>
                                {t('Fablia')}
                            </Menu.Item>
                            <Menu.Item onClick={toggleMenu} style={{ color: '#fff' }}>
                                <Icon name="sidebar" />
                            </Menu.Item>
                        </Container>
                    </Menu>
                </>
            ) : (
                /* Desktop Menu */
                <Menu
                    vertical={isMobile}
                    fixed="top"
                    inverted={!fixed}
                    pointing={!fixed}
                    secondary={!fixed}
                    size="large"
                    style={{ backgroundColor: '#00201f', border: 'none', boxShadow: 'none' }}
                >
                    <Container style={{ display: 'flex', padding: '0' }}>
                        <Menu.Item as={Link} to="/" style={{
                            backgroundColor: '#00201f',
                            padding: '0 1rem 0 0',
                        }}>
                            <SemanticImage
                                src={logoSrc}
                                style={{ height: '40px' }}
                                alt="Logo Fablia"
                                key="logoStoriaClean"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    setLogoSrc(logoStoriaCleanWebp);
                                }}
                            />
                        </Menu.Item>
                        <Menu.Item as={Link} to="/" active style={{ backgroundColor: '#00201f', color: '#fff' }}>
                            {t('Home')}
                        </Menu.Item>
                        <Menu.Item as={Link} to="/SelectStory" style={{ backgroundColor: '#00201f', color: '#fff' }}>
                            {t('Story Mode')}
                        </Menu.Item>
                        <Menu.Item as={Link} to={env.user ? "/Create" : "/CreateHomePage"} style={{ backgroundColor: '#00201f', color: '#fff' }}>
                            {t('Creation Mode')}
                        </Menu.Item>
                        { env.flyMode && <Menu.Item as={Link} to="/SelectStory?fly=true" style={{ backgroundColor: '#00201f', color: '#fff' }}>
                            {t('Improvisation Mode')}
                        </Menu.Item> }
                        <Menu.Item position="right" style={{ backgroundColor: '#00201f', color: '#fff' }}>
                            {!env.user ? (
                                <>
                                    <CreditsWidget />
                                    <Button as={Link} to="/login" inverted style={{ marginLeft: '0.5em' }}>
                                        {t('LogIn')}
                                    </Button>
                                    <Button as={Link} to="/signup" style={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
                                        {t('SignUp')}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    {env.user.photoURL && (
                                        <SemanticImage src={env.user.photoURL} avatar alt="Profile Image" />
                                    )}
                                    <span style={{ color: '#fff', marginRight: '0.5em' }}>
                                        {env.user.displayName || env.user.email}
                                    </span>
                                    <CreditsWidget />
                                    <Popup
                                        content={t('SignOut')}
                                        trigger={
                                            <Button
                                            onClick={handleSignOut}
                                            style={{
                                                marginLeft: '0.5em',
                                                marginRight: '0.5em',
                                                paddingRight: '0.5em',
                                                paddingLeft: '0.5em',
                                                backgroundColor: 'transparent',
                                                color: '#fff'
                                            }}
                                            >
                                            <Icon name="sign-out" inverted style={{ marginRight: 0, marginLeft: 0, color: '#fff' }} />
                                            </Button>
                                        }
                                    />
                                </>
                            )}
                            <Popup
                                content={t('Settings')}
                                trigger={
                                    <Menu.Item position="right" as={Link} to="/settings" style={{ marginLeft: '0.5em', marginRight: '0.5em', paddingRight: '0', paddingLeft: '0', }}>
                                        <Icon name="setting" inverted style={{ marginRight: 0, marginLeft: 0, color: '#fff' }} />
                                        </Menu.Item>
                                }
                            />
                            <Menu.Item position="right" style={{ paddingLeft: '0.5em' }}>
                                <LanguageDropdown />
                            </Menu.Item>
                        </Menu.Item>
                    </Container>
                </Menu>
            )}
        </>
    );
};

export default Navbar;
